<!-- Sign Up Form -->
<form aria-label="Sign Up"
    [formGroup]="signUpForm"
    (ngSubmit)="signupSubmit()"
    class="login-section pmd-form-card mb-3">
    <div class="step-1"
        *ngIf="step === 1">
        <div class="mb-3">
            <h2 class="card-title mb-1">Welcome to Purchase App</h2>
            <p class="card-subtitle">Share your details to create an account</p>
        </div>
        <pmd-alert type="danger"
            *ngIf="errorMessageSignUp">
            {{ errorMessageSignUp }}
        </pmd-alert>
        <pmd-alert type="success"
            *ngIf="successMessageSignUp">
            {{ successMessageSignUp }}
        </pmd-alert>
        <div [ngClass]="sharedService.pmdStatusClass(f.name, isSubmitAttempted)"
            class="mb-3">
            <label for="fullName"
                class="col-form-label">Full Name <span class="text-danger"
                    aria-label="required">*</span></label>
            <pmd-textfield pmd-textfield-outline
                class="mb-0">
                <input id="fullName"
                    [pattern]="appGlobals.regex['onlyCharacter']"
                    formControlName="name"
                    [ngClass]="sharedService.pmdStatusClass(f.name, isSubmitAttempted)"
                    maxlength="25"
                    type="text"
                    class="form-control">
            </pmd-textfield>
            <div *ngIf="sharedService.hasErrors(f.name, isSubmitAttempted)"
                class="invalid-feedback">
                <ng-container *ngIf="f.name.errors.required">
                    Name is required
                </ng-container>
                <ng-container *ngIf="f.name.errors.pattern">
                    Enter a valid name.
                </ng-container>
            </div>
        </div>

        <div [ngClass]="sharedService.pmdStatusClass(f.email, isSubmitAttempted)"
            class="mb-3">
            <label for="loginemail"
                class="col-form-label">Email ID <span class="text-danger"
                    aria-label="required">*</span></label>
            <pmd-textfield pmd-textfield-outline
                class="mb-0">
                <input id="loginemail"
                    formControlName="email"
                    maxlength="50"
                    [ngClass]="sharedService.pmdStatusClass(f.email, isSubmitAttempted)"
                    type="text"
                    class="form-control">
            </pmd-textfield>
            <div *ngIf="sharedService.hasErrors(f.email, isSubmitAttempted)"
                class="invalid-feedback">
                <ng-container *ngIf="f.email.errors.required || f.email.errors.pattern">
                    Enter a valid email id.
                </ng-container>
                <ng-container *ngIf="f.email.errors.uniqueEmail">
                    Email is already associated with us.
                </ng-container>
            </div>
        </div>

        <div class="mb-3">
            <div [ngClass]="sharedService.pmdStatusClass(f.mobile, isSubmitAttempted)">
                <label for="mobile"
                    class="col-form-label">Mobile Number <span class="text-danger"
                        aria-label="required">*</span></label>
                <pmd-textfield pmd-textfield-outline
                    class="mb-0 position-relative">
                    <div class="mobile-number-field">
                        +91
                    </div>
                    <input type="tel"
                        id="mobile"
                        formControlName="mobile"
                        [ngClass]="sharedService.pmdStatusClass(f.mobile, isSubmitAttempted)"
                        maxlength="10"
                        class="form-control mobile-input">
                </pmd-textfield>
            </div>
            <div *ngIf="sharedService.hasErrors(f.mobile, isSubmitAttempted)"
                class="invalid-feedback">
                <ng-container *ngIf="f.mobile.errors.required || f.mobile.errors.pattern">
                    Enter a valid mobile number
                </ng-container>
                <ng-container *ngIf="f.mobile.errors.uniqueMobile">
                    Mobile number is already associated with us.
                </ng-container>
            </div>
        </div>
        <div class="mb-3"
            [ngClass]="sharedService.pmdStatusClass(f.password, isSubmitAttempted)">
            <div [ngClass]="sharedService.pmdStatusClass(f.password, isSubmitAttempted)">
                <label for="Password2"
                    class="col-form-label">Password <span class="text-danger"
                        aria-label="required">*</span></label>
                <pmd-textfield pmd-textfield-outline
                    class="mb-0 position-relative">
                    <input id="Password2"
                        #passwordInput
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        maxlength="25"
                        [ngClass]="sharedService.pmdStatusClass(f.password, isSubmitAttempted)"
                        formControlName="password"
                        class="form-control"
                        aria-label="Password2"
                        aria-describedby="Password2">
                    <i class="material-symbols-outlined md-dark visibility-icon fs-20 pf-cursor-pointer"
                        (click)="togglePasswordVisibility()">
                        {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
                    </i>
                </pmd-textfield>

            </div>

            <div *ngIf="sharedService.hasErrors(f.password, isSubmitAttempted)"
                class="invalid-feedback">
                <ng-container
                    *ngIf="f.password.errors.required || f.password.errors.minlength || f.password.errors.pattern">
                    Enter a valid password
                </ng-container>
            </div>
        </div>
        <ul class="pf-pass-valid-list mb-3">
            <li class="pf-pass-valid-item"
                [class.valid-point]="isRequirementMet(appGlobals.regex.lowerCase)">
                One lowercase character
            </li>
            <li class="pf-pass-valid-item"
                [class.valid-point]="isRequirementMet(appGlobals.regex.upperCase)">
                One uppercase character
            </li>
            <li class="pf-pass-valid-item"
                [class.valid-point]="isRequirementMet(appGlobals.regex.symbol)">
                One special character
            </li>
            <li class="pf-pass-valid-item"
                [class.valid-point]="isRequirementMet(appGlobals.regex.length(8))">
                8 characters minimum
            </li>
            <li class="pf-pass-valid-item"
                [class.valid-point]="isRequirementMet(appGlobals.regex.number)">
                One number
            </li>
        </ul>
        <div>
            <div class="d-md-flex align-items-center">
                <button type="submit"
                    [disabled]="!signUpForm.valid"
                    [attr.aria-disabled]="!signUpForm.valid"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary"
                    class="col-auto me-3">Sign Up</button>
                <em class="d-block mt-3 mt-md-0 fs-12"> By creating this account, you agree to our
                    <br><a href="javascript: void(0);"
                        target="_blank"
                        routerLink="/privacy">
                        privacy policy
                    </a>
                    and
                    <a href="javascript: void(0);"
                        target="_blank"
                        routerLink="/terms">terms of use.
                    </a>
                </em>
            </div>
            <p class="mt-4 mb-0">Already registered with us?
                <a routerLink="/"
                    class="link-text text-dark">Sign In
                </a>
            </p>
        </div>
    </div>
</form>

<form *ngIf="step === 2"
    [formGroup]="verifyOtpForm"
    (ngSubmit)="verifyOtp()">
    <div class="step-2">
        <pmd-alert type="danger"
            *ngIf="errorMessageVerify && !successMessageVerify">
            {{ errorMessageVerify }}
        </pmd-alert>
        <pmd-alert type="success"
            *ngIf="successMessageVerify && !errorMessageVerify">
            {{ successMessageVerify }}
        </pmd-alert>
        <div class="mb-4">
            <h2 class="card-title mb-1">Verify Your Account</h2>
            <p class="card-subtitle">Please enter the verification code sent to you on your email id: <strong>{{
                    getMaskedEmail() }} </strong> or on your mobile number: <strong> {{
                    getMaskedMobileNumber(user.mobile) }} </strong>.</p>
        </div>
        <div class="d-flex gap-3 justify-content-center khr-forgot-pw">
            <pmd-textfield pmd-textfield-outline>
                <input #count1Input
                    (input)="moveFocus(count1Input, count2Input,null); onInputChange()"
                    id="count1"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count1, isSubmitAttempted)"
                    formControlName="count1"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline>
                <input #count2Input
                    (input)="moveFocus(count2Input, count3Input,count1Input); onInputChange()"
                    id="count2"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count2, isSubmitAttempted)"
                    formControlName="count2"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline>
                <input #count3Input
                    (input)="moveFocus(count3Input, count4Input,count2Input); onInputChange()"
                    id="count3"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count3, isSubmitAttempted)"
                    formControlName="count3"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline>
                <input #count4Input
                    (input)="moveFocus(count4Input, count5Input,count3Input); onInputChange()"
                    id="count4"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count4, isSubmitAttempted)"
                    formControlName="count4"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline>
                <input #count5Input
                    (input)="moveFocus(count5Input, count6Input,count4Input); onInputChange()"
                    id="count5"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count5, isSubmitAttempted)"
                    formControlName="count5"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
            <pmd-textfield pmd-textfield-outline>
                <input #count6Input
                    (input)="moveFocus(count6Input, count6Input,count5Input); onInputChange()"
                    id="count6"
                    [ngClass]="sharedService.pmdStatusClass(verifyf.count6, isSubmitAttempted)"
                    formControlName="count6"
                    maxlength="1"
                    type="text"
                    class="form-control text-center"
                    (keypress)="sharedService.numberOnly($event)"
                    (paste)="sharedService.numberOnly($event)">
            </pmd-textfield>
        </div>
        <div class="d-flex mt-3">
            <p class="mb-0"
                [class.disabled-section]="disableResendButton">
                <a href="javascript:void(0);"
                    (click)="reSendCodeSubmit();"
                    [class.disabled-link]="disableResendButton">Resend code</a>
            </p>
            <span class="ms-auto">{{ time }}</span>


        </div>
        <div class="mt-4">
            <button pmdRipple
                [disabled]="!verifyOtpForm.valid || disableButtonOnError"
                [attr.aria-disabled]="!verifyOtpForm.valid || disableButtonOnError"
                type="submit"
                pmd-btn-raised
                color="secondary">Verify Code</button>
            <p class="mt-3 mb-0"
                class="link-text mt-3">
                <span [pmdPopover]="popTemplate"
                    container="body"
                    placement="bottom"
                    containerClass="turnOverPopUp pmd-card mb-1"
                    class="py-2">Did not receive the verification code?</span>
            </p>
            <ng-template #popTemplate>
                <div class="verification-code">
                    <div class="title-info">If you have not received a verification code on your email id or your mobile
                        number:</div>
                    <ul class="list-group pmd-list mb-3">
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">email</span>
                            <span>Check your email inbox spam folder.</span>
                        </li>
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">refresh</span>
                            <span>Try "Resend code" option above.</span>
                        </li>
                        <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                                class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">check</span>
                            <span>Please check if you have entered a correct email id and mobile number.</span>
                        </li>
                    </ul>
                    <p>For any further assistance please contact our support team at <a
                            href="mailto:support@kharchaapp.com"
                            target="_blank">[support@purchaseapp.com]</a>.</p>
                </div>
            </ng-template>
        </div>
    </div>
</form>

<form *ngIf="step === 3"
    [formGroup]="companyDetailsForm"
    (ngSubmit)="companyDetailsSubmit()"
    class="pmd-form-card">
    <div class="step-3">
        <div class="mb-4">
            <h2 class="card-title mb-1">Your account is verified successfully. </h2>
            <p class="card-subtitle">Please add your company details to sign up process.</p>
            <pmd-alert type="success"
                *ngIf="successMsgCmpInfoAdd">
                {{ successMsgCmpInfoAdd }}
            </pmd-alert>
            <pmd-alert type="danger"
                *ngIf="errorMsgCmpInfoAdd">
                {{ errorMsgCmpInfoAdd }}
            </pmd-alert>
        </div>
        <div class="mb-3">
            <label for="gstNumber"
                class="col-form-label">GST Number</label>
            <pmd-textfield pmd-textfield-outline>
                <input id="gstNumber"
                    type="text"
                    formControlName="gst"
                    class="form-control text-uppercase"
                    (keyup)="onGSTAdd()"
                    (change)="onGSTAdd()">
            </pmd-textfield>
            <div *ngIf="companyDetailsForm.get('gst').invalid && companyDetailsForm.get('gst').touched"
                class="text-danger">
                <div *ngIf="companyDetailsForm.get('gst').errors.pattern">Invalid GST Number.</div>
            </div>
        </div>
        <div [ngClass]="sharedService.pmdStatusClass(companyf.pan, isSubmitAttempted)"
            class="mb-3">
            <label for="panNumber"
                class="col-form-label">PAN<strong class="text-danger">*</strong></label>
            <pmd-textfield pmd-textfield-outline>
                <input id="panNumber"
                    [ngClass]="sharedService.statusClass(companyf.pan, isSubmitAttempted)"
                    formControlName="pan"
                    type="text"
                    class="form-control text-uppercase"
                    (keyup)="onPANChange()"
                    (change)="onPANChange()">
            </pmd-textfield>
            <div *ngIf="sharedService.hasErrors(companyf.pan, isSubmitAttempted)"
                class="text-danger">
                <div *ngIf="companyf.pan.errors.required">PAN is required.</div>
                <div *ngIf="companyf.pan.errors.pattern">Invalid PAN.</div>
                <div *ngIf="companyf.pan.errors?.PANNotMatching">PAN does not match with GST Number.</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="compnayName"
                class="col-form-label">Company Name <strong class="text-danger">*</strong></label>
            <pmd-textfield pmd-textfield-outline>
                <input id="compnayName"
                    type="text"
                    [ngClass]="sharedService.pmdStatusClass(companyf.name, isSubmitAttempted)"
                    formControlName="name"
                    class="form-control">
            </pmd-textfield>
            <div *ngIf="sharedService.hasErrors(companyf.name, isSubmitAttempted)"
                class="text-danger">
                <div *ngIf="companyf.name.errors.required">Company Name is required.</div>
                <div *ngIf="companyf.name.errors.pattern">Invalid company name.</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="compnayName"
                class="col-form-label">Type Of Business</label>
            <ng-select [searchable]="true"
                [markFirst]="false"
                [items]="typeOfBussinessData"
                appearance="outline"
                bindLabel="name"
                bindValue="id"
                class="pmd-select pmd-select-outline w-100"
                placeholder="Type Of Business"
                name="searchFilter"
                formControlName="domain"
                ng-click="active!= ng-select-opened">
                <ng-template ng-option-tmp
                    let-item="item">
                    <div class="pmd-checkbox-option">
                        {{item.name}}
                    </div>
                </ng-template>
                <ng-template ng-multi-label-tmp
                    let-items="typeOfBussinessData"
                    let-clear="clear">
                    <ng-container>
                        <div class="ng-value"
                            [ngClass]="{ 'ng-value-disabled' : item.disabled == true }"
                            *ngFor="let item of typeOfBussinessData | slice:0:2">
                            <span class="ng-value-icon right"
                                (click)="item.disabled == true ? null : clear(item)"
                                aria-hidden="true">×</span>
                            <span class="ng-value-label">{{item.name}}</span>
                        </div>
                        <div class="ng-value ts-more"
                            *ngIf="typeOfBussinessData.length > 3">
                            <span class="ng-value-label">{{typeOfBussinessData.length - 3}} more...</span>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-select>
        </div>
        <div *ngIf="isOtherSelected"
            class="mb-3">
            <label for="yourBusiness"
                class="col-form-label">Your Business</label>
            <pmd-textfield pmd-textfield-outline>
                <input id="yourBusiness"
                    formControlName="otherDomain"
                    type="text"
                    class="form-control">
            </pmd-textfield>
            <div *ngIf="companyf.otherDomain.invalid && companyf.otherDomain.touched"
                class="text-danger">
                <div *ngIf="companyf.otherDomain.errors.required">Your Business is required.</div>
            </div>
        </div>
        <div class="mt-3">
            <div class="d-md-flex align-items-center">
                <button [disabled]="!companyDetailsForm.valid"
                    type="submit"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary"
                    class="col-auto me-3">Get Started</button>
            </div>
        </div>
    </div>
</form>
<!-- EndSign Up Form -->